import { BlazeSlider } from './slider'
export type { BlazeConfig, MediaConfig } from './types'

export default BlazeSlider
import { BlazeSlider } from './slider'
export type { BlazeConfig, MediaConfig } from './types'

export default BlazeSlider
